import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { claRoutesMap } from './claRoutesMap'

const AppIataAerolinea = Loadable(lazy(() => import('./view/IataAerolinea')))
const AppAgenciaDeViaje = Loadable(lazy(() => import('./view/AgenciaDeViaje')))
const AppOrigen = Loadable(lazy(() => import('./view/OrigenServicio')))
const AppTipoTransaccion = Loadable(lazy(() => import('./view/TipoTransaccion')))

const clasificadorRoutes = [
  {
    path: claRoutesMap.iataAerolineas.path,
    element: <AppIataAerolinea />,
    auth: authRoles.admin,
  },
  {
    path: claRoutesMap.agenciaViajes.path,
    element: <AppAgenciaDeViaje />,
    auth: authRoles.admin,
  },
  {
    path: claRoutesMap.origenServicio.path,
    element: <AppOrigen />,
    auth: authRoles.admin,
  },
  {
    path: claRoutesMap.tipoTransaccion.path,
    element: <AppTipoTransaccion />,
    auth: authRoles.admin,
  },
]

export default clasificadorRoutes
